import {
  GetSignedAgreementsQuery,
  PaymentFrequency,
  SignedAgreementStatus,
} from "src/generated/graphql";
import { useState } from "react";
import AgreementRequest from "./AgreementRequests";
import AgreementListing from "./AgreementListing";
interface ClientOverProps {
  agreementData: GetSignedAgreementsQuery["signedAgreementMany"];
}

export type Request = {
  id: string;
  name: string;
  locationId: string;
  status: SignedAgreementStatus;
  paymentFrequency: PaymentFrequency;
};

const Agreements = ({ agreementData }: ClientOverProps) => {
  const [isRequest, setIsRequest] = useState(false);
  const [selectedAgreement, setSelectedAgreement] = useState<Request | null>(
    null
  );

  return isRequest && selectedAgreement ? (
    <AgreementRequest
      selectedAgreement={selectedAgreement}
      setIsRequest={setIsRequest}
    />
  ) : (
    <AgreementListing
      agreementData={agreementData}
      setIsRequest={setIsRequest}
      setSelectedAgreement={setSelectedAgreement}
    />
  );
};

export default Agreements;
